import { AthletePageTeaser } from "@/components/page-teaser/athlete-page-teaser";
import { AthleteSearchBlockPageProps } from "@/components/blocks/athlete-search-block/types";

export function AthleteSearchBlock(initial: AthleteSearchBlockPageProps) {
    return (
        <div className=" flex flex-col gap-5 py-10">
            <header>
                <h2 className={"mb-0"}>{initial.heading}</h2>
            </header>

            <AthletePageTeaser profiles={initial.subContent} />
        </div>
    )
}
